import { type ReactNode } from 'react';

import { replaceSlashedZero } from '../../core/typographyStyles.sty.js';
import { InnerHandler } from '../types/pie-chart.config.js';

/**
 * Total value slot component for donut chart.
 */
export const DonutChartInner = ({
  children,
}: {
  children: InnerHandler | ReactNode;
  // TODO: Strict mode
  //@ts-expect-error: Strict mode transition — `InnerHandler` in the `children` union is a function type that TypeScript doesn't accept as a valid JSX child
}) => <div className={replaceSlashedZero}>({children})</div>;

DonutChartInner['displayName'] = 'DonutChart.Inner';
